import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import BarnesContent from "./BarnesPumpContent";

class SupplierDetails extends React.Component {
  render() {
    return (
      <div className="col-lg-8 col-md-12">
        <Switch>
          <Route
            path="/suppliers/barnes/pumps"
            exact
            component={BarnesContent}
          />
          <Route path="/suppliers/barnes">
            <Redirect to="/suppliers/barnes/pumps" />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default SupplierDetails;
